import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions';
import LRU from 'lru-cache';

const ONE_HOUR = 1000 * 60 * 60;
const defaultCache = new LRU({ ttl: ONE_HOUR, max: 500 });

export default ({ $axios, app, env, store }, inject) => {
  inject('cache', {
    name: 'cache',
    init() {
      const defaults = $axios.defaults;

      defaults.adapter = throttleAdapterEnhancer(
        cacheAdapterEnhancer(defaults.adapter, {
          enabledByDefault: false,
          cacheFlag: 'useCache',
          defaultCache,
        }),
      );
    },
    reset() {
      defaultCache.clear();
    },
  });
};
